// Small reusable component to show a rating badge with color
export function RatingBadge({ rating }) {
  const getRatingColor = (rating) => {
    switch (rating) {
      case 1: return 'bg-red-600';
      case 2: return 'bg-red-400';
      case 3: return 'bg-orange-500';
      case 4: return 'bg-orange-300';
      case 5: return 'bg-yellow-400';
      case 6: return 'bg-yellow-300';
      case 7: return 'bg-lime-400';
      case 8: return 'bg-lime-500';
      case 9: return 'bg-green-600';
      case 10: return 'bg-blue-500';
      default: return 'bg-gray-300';
    }
  };

  return (
    <div className={`w-10 h-10 rounded-full flex items-center justify-center ${getRatingColor(rating)} text-white font-bold text-lg`}>
      {rating}
    </div>
  );
}
